// extracted by mini-css-extract-plugin
export var container = "header-module--container--XLnQW";
export var header = "header-module--header--Zms1V";
export var logo = "header-module--logo--mTLiM";
export var nav = "header-module--nav--e8OJ3";
export var searchButton = "header-module--searchButton--FaX7C";
export var tinyHeader = "header-module--tinyHeader--BCPFH";